






































































































































import moment from 'moment'
import _ from 'lodash'
import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AgendaGarantiaMinimaStore from '@/components/RemuneracaoMedica/financeiro/Store/AgendaGarantiaMinimaStore'
import AntecipacaoRecebiveisStore from '@/components/RemuneracaoMedica/financeiro/Store/AntecipacaoRecebiveisStore'
import EventBus from '@/plugins/EventBus'
import { IRequestMessage, MensagensDaApiEnum, RequestMessage } from '@/types/_'
import { formatDateOnly, maskMoney, timeout } from '@/utils/common'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'

@Component
export default class ViewFinanceiroAntecipacoesRecebiveis extends Vue {
  search: string = ''
  loadingSearch: boolean = false
  getRequestMessage: IRequestMessage = new RequestMessage()
  statusResumo: string = 'Solicitado'

  get statusResumoItems() {
    return (this.obterResumoAntecipacaoBackoffice || []).map((r: any) => ({
      text: r.status,
      value: r.status,
    }))
  }

  get valorTotalExibido(): string {
    const resumo = this.obterResumoAntecipacaoBackoffice || []
    const found = resumo.find((r: any) => r.status === this.statusResumo)
    const total = found ? found.valorTotal : 0

    return this.formatMoney(total)
  }

  get statusResumoClass(): string {
    const map: Record<string, string> = {
      Aprovado: 'badge-aprovado',
      Solicitado: 'badge-solicitado',
    }
    return map[this.statusResumo] || 'badge-solicitado'
  }

  get situacoes() {
    return this.antecipacaoRecebiveisStore.situacoes
  }

  get antecipacaoRecebiveisStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  get headers() {
    return [
      { text: 'Empresa médica', value: 'empresaMedica', align: 'center', sortable: false },
      { text: 'Hospital', value: 'hospital', align: 'center', sortable: false },
      { text: 'Valor ofertado', value: 'valorOfertado', align: 'center', sortable: false },
      { text: 'Valor solicitado', value: 'valorSolicitado', align: 'center', sortable: false },
      { text: 'Valor líquido antecipado', value: 'valorLiquidoAntecipado', align: 'center', sortable: false },
      { text: 'Solicitado em', value: 'solicitadoEm', align: 'center', sortable: false },
      { text: 'Situação', value: 'situacao', align: 'center', sortable: false },
    ]
  }

  get items() {
    return this.antecipacaoRecebiveisStore.antecipacoesList
  }

  get situacao() {
    return this.antecipacaoRecebiveisStore.filtroSituacao
  }

  set situacao(value: any) {
    this.antecipacaoRecebiveisStore.setFiltroSituacao(value)
  }

  get getPagina() {
    return this.antecipacaoRecebiveisStore.pagina
  }

  set getPagina(value: number) {
    this.antecipacaoRecebiveisStore.setPagina(value)
  }

  get itemsLength() {
    return Math.ceil(this.antecipacaoRecebiveisStore.totalRegistros / this.antecipacaoRecebiveisStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get obterResumoAntecipacaoBackoffice() {
    return this.antecipacaoRecebiveisStore.resumoAntecipacaoBackoffice
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.antecipacaoRecebiveisStore.getAllAntecipacoes()
    EventBus.$emit('clearLoadingRequest')
  }

  formatDate(date: any) {
    return formatDateOnly(date)
  }

  formatMoney(value: any) {
    return maskMoney(value)
  }

  showAdvancedFilters() {
    this.antecipacaoRecebiveisStore.setDrawer(!this.antecipacaoRecebiveisStore.drawer)
  }

  irParaImportacaoPagamentos() {
    this.$router.push('/financeiro-importacao-pagamentos')
  }

  irParaLiquidacoesRecebiveis() {
    this.$router.push('/financeiro-liquidacoes-recebiveis')
  }

  async clearAdvancedFilters() {
    this.antecipacaoRecebiveisStore.clearFiltroAvançado()
    this.antecipacaoRecebiveisStore.setFilterOn(false)
    this.antecipacaoRecebiveisStore.setDrawer(false)
    this.getPagina = 1
    await this.antecipacaoRecebiveisStore.getAllAntecipacoes()
  }

  async filtrarPorSituacao() {
    this.getPagina = 1
    await this.antecipacaoRecebiveisStore.getAllAntecipacoes()
  }

  searchDebounce = _.debounce((searchTerm: string) => {
    this.performSearch(searchTerm)
  }, 300)

  async performSearch(searchTerm: string) {
    this.loadingSearch = true
    this.antecipacaoRecebiveisStore.setSearch(searchTerm)
    this.getPagina = 1

    await this.antecipacaoRecebiveisStore.getAllAntecipacoes()
    this.loadingSearch = false
  }

  clearPrestadorSearch() {
    this.search = ''
    this.antecipacaoRecebiveisStore.setSearch('')
    this.performSearch('')
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.statusResumo = 'Solicitado'
    await this.antecipacaoRecebiveisStore.getAllAntecipacoes()
    await this.antecipacaoRecebiveisStore.getSituacoes()
    await this.antecipacaoRecebiveisStore.getLocaisExecucaoList()
    await this.antecipacaoRecebiveisStore.obterResumoAntecipacaoBackoffice()
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }
}
